import apiClient from "./axios"

// Get all customer types with optional filtering
export const getCustomerTypes = async (params = {}) => {
  const { data } = await apiClient.get("/customer-types", { params })
  return data
}

// Get a specific customer type by ID
export const getCustomerType = async id => {
  const { data } = await apiClient.get(`/customer-types/${id}`)
  return data
}

// Create a new customer type
export const createCustomerType = async typeData => {
  const { data } = await apiClient.post("/customer-types", typeData)
  return data
}

// Update an existing customer type
export const editCustomerType = async ({ id, ...typeData }) => {
  const { data } = await apiClient.patch(`/customer-types/${id}`, typeData)
  return data
}

// Delete a customer type (soft delete)
export const deleteCustomerType = async id => {
  const { data } = await apiClient.delete(`/customer-types/${id}`)
  return data
}

// Get all customer types without pagination
export const getAllCustomerTypes = async (params = {}) => {
  const { data } = await apiClient.get("/customer-types", {
    params: { ...params, all: true },
  })
  return data
}

// Search customer types by name or slug
export const searchCustomerTypes = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customer-types", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed customer types
export const getTrashedCustomerTypes = async (params = {}) => {
  const { data } = await apiClient.get("/customer-types/trashed", { params })
  return data
}

// Get a customer type by slug
export const getCustomerTypeBySlug = async slug => {
  const { data } = await apiClient.get(`/customer-types/slug/${slug}`)
  return data
}

// Restore a trashed customer type
export const restoreCustomerType = async id => {
  const { data } = await apiClient.post(`/customer-types/${id}/restore`)
  return data
}
